/* eslint-disable no-unused-vars */
import {
  Button,
  Col,
  DatePicker,
  Input,
  Modal,
  Row,
  Table,
  Tooltip,
  Typography,
  notification,
} from "antd";

import React, { useEffect, useRef, useState } from "react";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import moment from "moment";
import SelectOption from "../../pos/components/SelectOption";
import { useHttp } from "../../../../hooks/http";
import { getToken, URL_API } from "../../../../utils";
import axios from "axios";
import SelectAllType from "../../../../components/SelectAllType";
import * as XLSX from "xlsx-js-style";
import { message } from "antdV4";
import { BiImport } from "react-icons/bi";
import { FaCogs, FaEdit, FaTrash } from "react-icons/fa";

const { Text } = Typography;
const { Search } = Input;
const limit = 30;
const pageSize = 20;

const Index = () => {
  const fileInputRef = useRef(null);
  const [memberTypeFilter, setMemberTypeFilter] = useState("");
  const [memberTypeFilterText, setMemberTypeFilterText] = useState("");
  const [status, setStatus] = useState("");
  const [statusText, setStatusText] = useState("");
  const [importStatusFilter, setImportStatusFilter] = useState("0");
  const [importStatusFilterText, setImportStatusFilterText] = useState("ยังไม่ถูกนำเข้า");

  const [modalStatusPage, setModalStatusPage] = useState(1);
  const [importPage, setImportPage] = useState(1);
  const [sheetName, setSheetName] = useState("");
  const [fileName, setFileName] = useState("");
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [resImportStatusData, setResImportStatusData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [previewImportData, setPreviewImportData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [page, setPage] = useState(1);

  const [date_from, setDateFrom] = useState(moment());
  const [date_to, setDateTo] = useState(moment());
  const [search, setSearch] = useState("");

  const source = axios.CancelToken.source();

  const memberTypeOptions = [
    { value: "", text: "ทั้งหมด" },
    { value: "Distributor", text: "นักธุรกิจ" },
    { value: "Member", text: "VIP MEMBER" },
  ];
  const importStatusOptions = [
    { value: "", text: "ทั้งหมด" },
    { value: "1", text: "นำเข้าแล้ว" },
    { value: "0", text: "ยังไม่ถูกนำเข้า" },
  ];

  const [loading, data, error, reload] = useHttp(
    {
      url: `${URL_API}/shopee/shopee/`,
      token: true,
      params: {
        limit,
        offset: limit * (page - 1),
        query: search,
        member_type_filter: memberTypeFilter,
        member_status: status,
        import_status: importStatusFilter,
      },
      initialLoad: true,
    },
    [search, memberTypeFilter, status, importStatusFilter],
  );

  const exportToExcel = async () => {
    try {
      const exportDataData = data?.data ? data?.data : [];

      if (exportDataData?.length !== 0) {
        let excelData = [
          ["บัญชีผู้ใช้ Shopee"],
          [`วันที่เอกสาร  ${moment(moment()).format("DD/MM/YYYY")}`],
          [
            `ค้นหาจาก : ${search === "" ? "-" : search}`,
            "",
            `ประเภทสมาชิก : ${memberTypeFilterText === "" ? "ทั้งหมด" : memberTypeFilterText}`,
            "",
            `สถานะ : ${statusText === "" ? "ทั้งหมด" : statusText}`,
            "",
          ],
          [""],
          [
            "No",
            "ประเภทสมาชิก",
            "รหัสสมาชิก",
            "ชื่อ - นามสกุล",
            "ทีม",
            "ผู้แนะนำ",
            "การนำเข้าระบบ Shopee",
            "ชื่อบัญชีผู้ใช้ Shopee",
            "สถานะ",
          ],
        ];

        exportDataData.forEach((n) => {
          excelData = [
            ...excelData,
            [
              { v: n.row_id, s: { alignment: { horizontal: "center" } } },
              { v: n.member_type, s: { alignment: { horizontal: "center" } } },
              { v: n.member_code, s: { alignment: { horizontal: "center" } } },
              { v: n.partner_name, s: { alignment: { horizontal: "left" } } },
              { v: n.team_name, s: { alignment: { horizontal: "left" } } },
              {
                v: n.sponsor_code + " : " + n.sponsor_name,
                s: { alignment: { horizontal: "left" } },
              },
              {
                v: n.integrated_date
                  ? moment(n.integrated_date).format("DD/MM/YY HH:mm")
                  : "",
                s: { alignment: { horizontal: "left" } },
              },
              { v: n.account_name, s: { alignment: { horizontal: "left" } } },
              { v: n.status_text, s: { alignment: { horizontal: "center" } } },
            ],
          ];
        });

        const merge = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } },
          { s: { r: 1, c: 0 }, e: { r: 1, c: 2 } },
          { s: { r: 2, c: 0 }, e: { r: 2, c: 1 } },
          { s: { r: 2, c: 2 }, e: { r: 2, c: 3 } },
          { s: { r: 2, c: 4 }, e: { r: 2, c: 5 } },
        ];

        var wscols = [
          { wch: 10 },
          { wch: 20 },
          { wch: 15 },
          { wch: 30 },
          { wch: 12 },
          { wch: 35 },
          { wch: 30 },
          { wch: 30 },
          { wch: 25 },
        ];

        const ws = XLSX.utils.aoa_to_sheet(excelData);
        ws["!cols"] = wscols;
        //ws["!rows"] = wsrows;
        ws["!merges"] = merge;

        const wb = XLSX.utils.book_new();
        const fileName = `${moment().format("YYMMDD")}-บัญชีผู้ใช้Shopee.xlsx`;

        XLSX.utils.book_append_sheet(wb, ws, "บัญชีผู้ใช้ Shopee");
        XLSX.writeFile(wb, fileName);
      } else {
        notification.warning({
          message: "ไม่มีข้อมูล",
          description: "ไม่มีข้อมูลสำหรับสร้างไฟล์ excel กรุณาตรวจสอบข้อมูล",
          top: 60,
        });
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  const importAccountShopee = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      const json = XLSX.utils.sheet_to_json(worksheet, {
        range: 1, // ข้าม header แถวแรก
        header: ["account_name"],
        defval: "",
      });

      const duplicates = new Set();
      const seenNames = new Set();

      json.forEach((item) => {
        const accountName = item.account_name ? item.account_name.trim() : "";

        if (!accountName) return;

        if (seenNames.has(accountName)) {
          duplicates.add(accountName);
        } else {
          seenNames.add(accountName);
        }
      });

      if (duplicates.size > 0) {
        const duplicateList = [...duplicates].join(", ");
        Modal.warning({
          title: "พบข้อมูลชื่อบัญชีซ้ำในไฟล์",
          content: `ตรวจพบชื่อบัญชี Shopee ซ้ำกันภายในไฟล์ : ${duplicateList} กรุณาแก้ไขข้อมูลให้ถูกต้องก่อนนำเข้า`,
        });
        return;
      }
      setSheetName(firstSheetName);
      setFileName(file.name);
      setPreviewImportData(json);
      setImportPage(1);
      setPreviewModalVisible(true);
    };

    reader.readAsArrayBuffer(file);
    event.target.value = null;
  };

  const handleAddStampTime = async (record) => {
    try {
      const token = getToken();

      const accountName = record.account_name;

      const response = await axios.post(
        `${URL_API}/shopee/shopee/add-stamp-time`,
        {
          account_name: accountName,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success) {
        reload();
      }
    } catch (error) {
      console.error("Error adding stamp time:", error);
    }
  };
  const handleRemoveStampTime = (record) => {
    const accountName = record.account_name;

    Modal.confirm({
      title: "ยืนยันการลบข้อมูล?",
      content: `คุณต้องการลบวันที่นำเข้าระบบของบัญชี "${accountName}" ใช่หรือไม่?`,
      okText: "ยืนยัน",
      okType: "danger",
      cancelText: "ยกเลิก",
      onOk: async () => {
        try {
          const token = getToken();

          const response = await axios.post(
            `${URL_API}/shopee/shopee/remove-stamp-time`,
            {
              account_name: accountName,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.data.success || response.status === 200) {
            reload();
          }
        } catch (error) {
          console.error("Error removing stamp time:", error);
        }
      },
    });
  };

  const exportFailList = () => {
    // กรองเอาเฉพาะข้อมูลที่มีคำว่า failed ในสถานะ
    const failData = resImportStatusData.filter((item) =>
      item.status?.toLowerCase().includes("failed")
    );

    if (failData.length === 0) {
      notification.warning({
        message: "ไม่มีข้อมูลที่ล้มเหลว",
        description: "ไม่พบรายการที่มีสถานะ 'fail'",
      });
      return;
    }

    const headers = ["ชื่อบัญชีผู้ใช้ Shopee"];
    const rows = failData.map((item) => [item.account_name]);

    const wsData = [headers, ...rows];

    var wscols = [{ wch: 40 }]; // ปรับความกว้างคอลัมน์ A ให้กว้างขึ้นรองรับชื่อยาวๆ

    const centerStyles = {
      alignment: {
        vertical: "center",
        horizontal: "center",
      },
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } },
      },
      fill: { fgColor: { rgb: "E9E9E9" } },
    };

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    ws["!cols"] = wscols;

    // ใส่สไตล์เฉพาะคอลัมน์ A1 ที่มีข้อมูลอยู่จริง
    ["A1"].forEach((cell) => {
      if (ws[cell]) {
        ws[cell].s = centerStyles;
      }
    });

    XLSX.utils.book_append_sheet(wb, ws, "Fail List");
    XLSX.writeFile(wb, "import-shopee-fail-list.xlsx");
  };

  return (
    <Panel>
      <PanelHeader>บัญชีผู้ใช้ Shopee</PanelHeader>
      <PanelBody>
        <input
          type="file"
          accept=".xlsx, .xls, .csv, text/csv"
          ref={fileInputRef}
          onChange={importAccountShopee}
          style={{ display: "none" }}
        />
        <Row gutter={12} type="flex" className="align-items-center mb-5 mt-3">
          <Col span={6}>
            <Search
              placeholder="ค้นหาจาก รหัสมสมาชิก, รหัสนักธุรกิจ หรือ บัญชีผู้ใช้ Shopee"
              onSearch={(value) => {
                setPage(1);
                setSearch(value);
              }}
              allowClear
            />
          </Col>
          <Col className="pl-4">
            <Text strong>ประเภทสมาชิก</Text>
          </Col>
          <Col span={2}>
            <SelectOption
              className="w-100"
              defaultValue={memberTypeFilter}
              options={memberTypeOptions}
              onChange={(value, option) => {
                setPage(1);
                setMemberTypeFilter(value);
                setMemberTypeFilterText(option?.props?.children || "");
              }}
            />
          </Col>
          <Col className="text-right pl-4">
            <Typography.Text strong className="text-nowrap">
              สถานะ
            </Typography.Text>
          </Col>
          <Col md={2}>
            <SelectAllType
              className="w-100"
              process_type={
                memberTypeFilter === "member"
                  ? "member_status_local"
                  : "partner_status_local"
              }
              withAll
              allText="ทั้งหมด"
              allowClear
              value={status}
              onChange={(value, option) => {
                setPage(1);
                setStatus(value);
                setStatusText(option?.props?.children || "");
              }}
            />
          </Col>
          <Col className="pl-4">
            <Text strong>การนำเข้าระบบ Shopee</Text>
          </Col>
          <Col span={2}>
            <SelectOption
              className="w-100"
              defaultValue={importStatusFilter}
              options={importStatusOptions}
              onChange={(value, option) => {
                setPage(1);
                setImportStatusFilter(value);
                setImportStatusFilterText(option?.props?.children || "");
              }}
            />
          </Col>
          <Col className="text-right pl-4">
            <Row gutter={8} type="flex" justify="end" className="mb-2 mt-2">
              <Col>
                <Button
                  type="dashed"
                  onClick={() => fileInputRef.current.click()}
                >
                  <BiImport size={12} className="mr-2" />
                  นำเข้ารายชื่อที่เพิ่มใน Shopee แล้ว
                </Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  className="text-white d-flex align-items-center"
                  icon="file-excel"
                  onClick={exportToExcel}
                >
                  Export Excel
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        <Table
          bordered
          size="small"
          dataSource={data?.data.length > 0 ? data?.data : []}
          rowKey="row_id"
          loading={loading}
          scroll={{ x: "max-content" }}
          pagination={{
            current: page,
            pageSize: limit,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
            total: data?.data.length,
            showLessItems: true,
            size: "default",
            onChange: (currPage) => setPage(currPage),
          }}
        >
          <Table.Column title="No" dataIndex="row_id" align="left" />
          <Table.Column
            title="ประเภทสมาชิก"
            dataIndex="member_type"
            align="left"
          />
          <Table.Column
            title="รหัสสมาชิก"
            dataIndex="member_code"
            align="left"
          />
          <Table.Column
            title="ชื่อ - นามสกุล"
            dataIndex="partner_name"
            align="left"
          />
          <Table.Column title="ทีม" dataIndex="team_name" align="left" />
          <Table.Column
            title="ผู้แนะนำ"
            dataIndex="sponsor_name"
            align="left"
            render={(_, record) => (
              <div>
                <div>
                  <Typography.Text>รหัส: </Typography.Text>
                  <Typography.Text>
                    {record.sponsor_code || "-"}
                  </Typography.Text>
                </div>
                <div>
                  <Typography.Text>ชื่อ: </Typography.Text>
                  <Typography.Text>
                    {record.sponsor_name || "-"}
                  </Typography.Text>
                </div>
              </div>
            )}
          />
          <Table.Column
            title="การนำเข้าระบบ Shopee"
            dataIndex="integrated_date"
            align="center"
            render={(integrated_date, record) =>
              integrated_date ? (
                <Row gutter={8}>
                  <Col span={19}>
                    {moment(integrated_date).format("DD/MM/YYYY HH:mm")}
                  </Col>
                  <Col span={5}>
                    <Tooltip title="ลบวันเวลานำเข้าระบบ Shopee">
                      <Button
                        size="small"
                        type="danger"
                        ghost
                        onClick={() => handleRemoveStampTime(record)}
                      >
                        <FaTrash />
                      </Button>
                    </Tooltip>
                  </Col>
                </Row>
              ) : (
                <Tooltip title="บันทึกวันเวลานำเข้าระบบ Shopee">
                  <Button
                    size="small"
                    type="primary"
                    ghost
                    onClick={() => handleAddStampTime(record)}
                  >
                    <FaEdit />
                  </Button>
                </Tooltip>
              )
            }
          />
          <Table.Column
            title="ชื่อบัญชีผู้ใช้ Shopee"
            dataIndex="account_name"
            align="left"
          />
          <Table.Column title="สถานะ" dataIndex="status_text" align="left" />
        </Table>

        <Modal
          title="ยืนยันการทำรายการ"
          visible={previewModalVisible}
          onCancel={() => setPreviewModalVisible(false)}
          width={800}
          zIndex={1080}
          footer={[
            <Button key="cancel" onClick={() => setPreviewModalVisible(false)}>
              ยกเลิก
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={isSubmitting}
              onClick={() => {
                setIsSubmitting(true);
                axios({
                  method: "post",
                  baseURL: URL_API,
                  url: `/shopee/shopee/import-stamp-time`,
                  headers: { Authorization: "Bearer " + getToken() },
                  data: {
                    import_data: previewImportData,
                    sheet_name: sheetName,
                    file_name: fileName,
                  },
                  cancelToken: source.token,
                })
                  .then((res) => {
                    const responseData = res.data?.data || [];
                    setResImportStatusData(responseData);
                    setIsModalVisible(true);
                    setPreviewModalVisible(false);
                  })
                  .catch((err) => {
                    Modal.error({
                      title: "ผิดพลาด",
                      content: err.response?.data?.message || err.message,
                      okText: "ตกลง",
                      zIndex: 1080,
                    });
                  })
                  .finally(() => {
                    setIsSubmitting(false);
                  });
              }}
            >
              บันทึก
            </Button>,
          ]}
        >
          <Table
            bordered
            size="small"
            dataSource={previewImportData.map((item, idx) => ({
              ...item,
              key: idx.toString(),
            }))}
            rowKey="key"
            pagination={{
              current: importPage,
              pageSize: pageSize,
              total: previewImportData.length,
              onChange: (currPage) => setImportPage(currPage),
              size: "default",
              showLessItems: false,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
            }}
          >
            <Table.Column
              title="ลำดับ"
              key="index"
              render={(_, __, index) => (importPage - 1) * pageSize + index + 1}
            />
            <Table.Column
              title="ชื่อบัญชีผู้ใช้ Shopee"
              dataIndex="account_name"
            />
          </Table>
        </Modal>

        <Modal
          title="ผลการนำเข้าข้อมูล"
          visible={isModalVisible}
          onCancel={() => {
            setIsModalVisible(false);
            reload();
          }}
          footer={[
            <Button key="export" onClick={exportFailList}>
              Export Fail List
            </Button>,
            <Button
              key="close"
              type="primary"
              onClick={() => {
                setIsModalVisible(false);
                reload();
              }}
              style={{ marginLeft: 8 }}
            >
              ตกลง
            </Button>,
          ]}
          width={800}
          zIndex={1080}
        >
          <Table
            bordered
            size="small"
            dataSource={resImportStatusData.map((item, index) => ({
              ...item,
              key: index,
            }))}
            pagination={{
              current: modalStatusPage,
              pageSize: pageSize,
              total: resImportStatusData.length,
              onChange: (page) => setModalStatusPage(page),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
              size: "default",
              showLessItems: false,
            }}
          >
            <Table.Column
              title="#"
              key="index"
              render={(_, __, index) =>
                (modalStatusPage - 1) * pageSize + index + 1
              }
            />
            <Table.Column
              title="ชื่อบัญชีผู้ใช้ Shopee"
              dataIndex="account_name"
            />
            <Table.Column
              title="status"
              dataIndex="status"
              render={(status) => {
                if (status?.toLowerCase().includes("duplicate")) {
                  return "ข้อมูลซ้ำ (ข้อมูลซ้ำจะไม่ถูกอัพเดทแทนที่ข้อมูลเดิม)";
                } else {
                  return status;
                }
              }}
            />
          </Table>

          <Row justify="space-between" className="mt-3">
            <Col>
              <Text>
                <span role="img" aria-label="success">
                  ✅
                </span>{" "}
                สำเร็จ:{" "}
                {
                  resImportStatusData.filter((item) =>
                    item.status?.toLowerCase().includes("success")
                  ).length
                }{" "}
                รายการ{" | "}

                {/* เพิ่มการแสดงจำนวนรายการที่ซ้ำ */}
                <span role="img" aria-label="duplicate">
                  🟡
                </span>{" "}
                ข้อมูลซ้ำ:{" "}
                {
                  resImportStatusData.filter((item) =>
                    item.status?.toLowerCase().includes("duplicate")
                  ).length
                }{" "}
                รายการ{" | "}

                <span role="img" aria-label="fail">
                  ❌
                </span>{" "}
                ไม่สำเร็จ:{" "}
                {
                  resImportStatusData.filter((item) =>
                    item.status?.toLowerCase().includes("failed")
                  ).length
                }{" "}
                รายการ
              </Text>
            </Col>
          </Row>
        </Modal>
      </PanelBody>
    </Panel>
  );
};

export default Index;
